module.exports = require("/tmp/build_0db602d8/src/lib/gatsby/gatsby-browser.tsx");